import { sessionConstants } from "@constants/appConstants";

import { getSessionItem, setSessionItem } from "@utils/sessionUtils";

export const getMldJobMap = () => JSON.parse(getSessionItem(sessionConstants.mldReportJobMap) || "{}");

// ---------------------------------------------------------------------------
// Cancelled-job registry
// When MldCancelReport successfully calls cancelMLDReport(), it marks the
// jobId here so the next pollMldJob iteration knows to exit immediately.
// ---------------------------------------------------------------------------
const _cancelledJobIds = new Set();

/** Mark a job as cancelled so the poll loop exits on its next iteration. */
export const markJobAsCancelled = jobId => _cancelledJobIds.add(String(jobId));

/**
 * Returns true (and removes the entry) if the job was externally cancelled.
 * Designed to be called once at the start of each poll iteration.
 */
export const consumeCancelledJob = jobId => {
  const key = String(jobId);
  if (!_cancelledJobIds.has(key)) return false;
  _cancelledJobIds.delete(key);
  return true;
};

export const setJobIdForProject = (pid, jobId) => {
  setSessionItem(sessionConstants.mldReportJobMap, JSON.stringify({ ...getMldJobMap(), [pid]: jobId }));
  window.dispatchEvent(new CustomEvent("mldJobMapUpdated"));
};
export const getProjectIdForJob = jobId => Object.entries(getMldJobMap()).find(([, id]) => id === jobId)?.[0];

export const removeJobIdForProject = pid => {
  const map = getMldJobMap();
  delete map[pid];
  setSessionItem(sessionConstants.mldReportJobMap, JSON.stringify(map));
  window.dispatchEvent(new CustomEvent("mldJobMapUpdated"));
};

/** Returns the pending MLD job ID stored for the given project, or null. */
export const getPendingMldJobId = projectId => {
  if (!projectId) return null;
  try {
    return getMldJobMap()[projectId] ?? null;
  } catch {
    return null;
  }
};

/**
 * Returns true if there is an MLD job running for ANY project other than currentProjectId.
 * Used to disable the report button when opening a different project while a job is in flight.
 */
export const hasOtherProjectJobRunning = currentProjectId => {
  try {
    const map = getMldJobMap();
    return Object.keys(map).some(pid => String(pid) !== String(currentProjectId));
  } catch {
    return false;
  }
};
